<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.firstName"
        :validator="vs.form.firstName"
        label="First name"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.lastName"
        :validator="vs.form.lastName"
        label="Last name"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.email"
        :disabled="true"
        label="Email"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.password"
        :validator="vs.form.password"
        label="Set new password"
        :error-messages="{ minLength: 'Password must have atleast 5 characters' }"
        type="password"
      />
    </v-flex>
  </v-layout>
</template>


<script>

export default {
  name: 'invite-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}

</script>

<style scoped>
</style>
